import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./View.css";
import Loader from "./Loader";
const API_URL = process.env.REACT_APP_API_URL;
const View = () => {
  const [threshold, setThreshold] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const mac = location.state?.id;
  const [loading, setloading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response3 = await fetch(
          `${API_URL}/getthreshold.php?getdata=${mac}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const json3 = await response3.json();
        setThreshold(json3);
        setloading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [mac]);

  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const menuItems = [
    {
      label: "Dashboard",
      icon: require("../img/dashboard.png"),
      route: "/dashboard",
    },
    ...(localStorage.getItem("role") === "Product Manager"
      ? [
        {
          label: "Product Managers",
          icon: require("../img/leader.png"),
          route: "/alluser",
        },
      ]
      : []),
    ...(localStorage.getItem("role") === "Product Manager" ||
      localStorage.getItem("role") === "Site Manager"
      ? [
        {
          label: "Site Managers",
          icon: require("../img/site-manager.png"),
          route: "/alluser",
        },
      ]
      : []),
    ...(localStorage.getItem("role") === "Product Manager" ||
      localStorage.getItem("role") === "Site Manager"
      ? [
        {
          label: "Technicians",
          icon: require("../img/labor.png"),
          route: "/alluser",
        },
      ]
      : []),
    ...(localStorage.getItem("role") !== "User"
      ? [
        {
          label: "Users",
          icon: require("../img/people1.png"),
          route: "/alluser",
        },
      ]
      : []),
    {
      label: "Devices",
      icon: require("../img/settings.png"),
      route: "/mac",
    },
    ...(localStorage.getItem("role") === "Product Manager" ||
      localStorage.getItem("role") === "Site Manager"
      ? [{ label: "Add", icon: require("../img/add.png"), route: "/adduser" }]
      : []),
    {
      label: "Logout",
      icon: require("../img/logout.png"),
      route: "/",
    },
  ];

  const [phlow, setphlow] = useState(0);
  // const [selectedSetting, setSelectedSetting] = useState("0");
  // const [selectedSettingName, setSelectedSettingName] = useState("");

  const [phhigh, setphhigh] = useState(0);
  const [name, setname] = useState("");
  const [orplow, setorplow] = useState(0);
  const [orphigh, setorphigh] = useState(0);
  const [dolow, setdolow] = useState(0);
  const [dohigh, setdohigh] = useState(0);
  const [templow, settemplow] = useState(0);
  const [temphigh, settemphigh] = useState(0);
  const [vollow, setvollow] = useState(0);
  const [volhigh, setvolhigh] = useState(0);
  const [currlow, setcurrlow] = useState(0);
  const [currentHigh, setcurrentHigh] = useState(0);
  const [c_phlow, setc_phlow] = useState(0);
  const [c_phhigh, setc_phhigh] = useState(0);
  const [c_orplow, setc_orplow] = useState(0);
  const [c_orphigh, setc_orphigh] = useState(0);
  const [c_dolow, setc_dolow] = useState(0);
  const [c_dohigh, setc_dohigh] = useState(0);
  const [c_templow, setc_templow] = useState(0);
  const [c_temphigh, setc_temphigh] = useState(0);
  const [c_vollow, setc_vollow] = useState(0);
  const [c_volhigh, setc_volhigh] = useState(0);
  const [c_currlow, setc_currlow] = useState(0);
  const [c_currentHigh, setc_currentHigh] = useState(0);
  const [o_time_on, seto_time_on] = useState(0);
  const [o_delay_after_on, seto_delay_after_on] = useState(0);
  const [o_ph_active_time, seto_ph_active_time] = useState(0);
  const [o_start_active_on, seto_start_active_on] = useState(0);
  const [o_dosing_gpio, seto_dosing_gpio] = useState(0);
  const [o_chlorine_pump_time, seto_chlorine_pump_time] = useState(0);
  const [o_alum_gpio, seto_alum_gpio] = useState(0);
  const [time_on, settime_on] = useState(0);
  const [delay_after_on, setdelay_after_on] = useState(0);
  const [ph_active_time, setph_active_time] = useState(0);
  const [start_active_on, setstart_active_on] = useState(0);
  const [dosing_gpio, setdosing_gpio] = useState(0);
  const [chlorine_pump_time, setchlorine_pump_time] = useState(0);
  const [alum_gpio, setalum_gpio] = useState(0);
  const [move_2, setmove_2] = useState("");
  const [move_station, setmove_station] = useState("");
  const [move_pwm, setmove_pwm] = useState("");
  const [stop, setstop] = useState("");
  const [read, setread] = useState("");
  const [info, setinfo] = useState("");
  const [status, setstatus] = useState("");
  const [ble_name, setble_name] = useState("");
  const [rs485command, setrs485command] = useState("");
  useEffect(() => {
    fetch(`${API_URL}/getthreshold.php?getdata=${mac}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        setphlow(parseFloat(responseData?.pHLow) || 0.0);
        setphhigh(parseFloat(responseData?.pHHigh) || 0.0);
        setorplow(parseFloat(responseData?.ORPLow) || 0.0);
        setorphigh(parseFloat(responseData?.ORPHigh) || 0.0);
        setdolow(parseFloat(responseData?.DOLow) || 0.0);
        setdohigh(parseFloat(responseData?.DOHigh) || 0.0);
        settemplow(parseFloat(responseData?.temperatureLow) || 0.0);
        settemphigh(parseFloat(responseData?.temperatureHigh) || 0.0);
        setvollow(parseFloat(responseData?.voltageLow) || 0.0);
        setvolhigh(parseFloat(responseData?.voltageHigh) || 0.0);
        setcurrlow(parseFloat(responseData?.currentLow) || 0.0);
        setcurrentHigh(parseFloat(responseData?.currentHigh) || 0.0);
        setc_phlow(parseFloat(responseData?.c_pHLow) || 0.0);
        setc_phhigh(parseFloat(responseData?.c_pHHigh) || 0.0);
        setc_orplow(parseFloat(responseData?.c_ORPLow) || 0.0);
        setc_orphigh(parseFloat(responseData?.c_ORPHigh) || 0.0);
        setc_dolow(parseFloat(responseData?.c_DOLow) || 0.0);
        setc_dohigh(parseFloat(responseData?.c_DOHigh) || 0.0);
        setc_templow(parseFloat(responseData?.c_temperatureLow) || 0.0);
        setc_temphigh(parseFloat(responseData?.c_temperatureHigh) || 0.0);
        setc_vollow(parseFloat(responseData?.c_voltageLow) || 0.0);
        setc_volhigh(parseFloat(responseData?.c_voltageHigh) || 0.0);
        setc_currlow(parseFloat(responseData?.c_currentLow) || 0.0);
        setc_currentHigh(parseFloat(responseData?.c_currentHigh) || 0.0);
        setname(responseData?.name);
        settime_on(parseInt(responseData?.time_on));
        setdelay_after_on(parseInt(responseData?.delay_after_on));
        setph_active_time(parseInt(responseData?.ph_active_time));
        setstart_active_on(parseFloat(responseData?.start_active_on));
        setdosing_gpio(parseFloat(responseData?.dosign_acid_current_gpio));
        setchlorine_pump_time(parseFloat(responseData?.chlorine_pump_time));
        setalum_gpio(parseFloat(responseData?.alum_current_gpio));
        seto_time_on(parseInt(responseData?.o_time_on));
        seto_delay_after_on(parseInt(responseData?.o_delay_after_on));
        seto_ph_active_time(parseInt(responseData?.o_ph_active_time));
        seto_start_active_on(parseFloat(responseData?.o_start_active_on));
        seto_dosing_gpio(parseFloat(responseData?.o_dosign_acid_current_gpio));
        seto_chlorine_pump_time(parseFloat(responseData?.o_chlorine_pump_time));
        seto_alum_gpio(parseFloat(responseData?.o_alum_current_gpio));
        setmove_station(responseData?.run_station?.split(",")[0]);
        setmove_pwm(responseData?.run_station?.split(",")[1]);
        setmove_2(responseData?.run_station?.split(",")[2]);
        setstop(responseData?.stop);
        setread(responseData?.read_command);
        setinfo(responseData?.info);
        setstatus(responseData?.status);
        setble_name(responseData?.ble_name);
        setrs485command(responseData?.rs485_command);
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, []);

  const sendthreshold = async (e) => {
    fetch(`${API_URL}/getthreshold.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pHHigh: phhigh || "",
        pHLow: phlow || "",
        ORPHigh: orphigh || "",
        ORPLow: orplow || "",
        DOHigh: dohigh || "",
        DOLow: dolow || "",
        temperatureHigh: temphigh || "",
        temperatureLow: templow || "",
        voltageHigh: volhigh || "",
        voltageLow: vollow || "",
        currentHigh: currentHigh || "",
        currentLow: currlow || "",
        c_pHHigh: c_phhigh || "",
        c_pHLow: c_phlow || "",
        c_ORPHigh: c_orphigh || "",
        c_ORPLow: c_orplow || "",
        c_DOHigh: c_dohigh || "",
        c_DOLow: c_dolow || "",
        c_temperatureHigh: c_temphigh || "",
        c_temperatureLow: c_templow || "",
        c_voltageHigh: c_volhigh || "",
        c_voltageLow: c_vollow || "",
        c_currentHigh: c_currentHigh || "",
        c_currentLow: c_currlow || "",
        mac: mac || "",
        name: name || "",
        time_on: time_on || "",
        delay_after_on: delay_after_on || "",
        ph_active_time: ph_active_time || "",
        start_active_on: start_active_on || "",
        dosign_acid_current_gpio: dosing_gpio || "",
        chlorine_pump_time: chlorine_pump_time || "",
        alum_current_gpio: alum_gpio || "",
        run_station: move_station + "," + move_pwm + "," + move_2 || "",
        o_time_on: o_time_on || "",
        o_delay_after_on: o_delay_after_on || "",
        o_ph_active_time: o_ph_active_time || "",
        o_start_active_on: o_start_active_on || "",
        o_dosign_acid_current_gpio: o_dosing_gpio || "",
        o_chlorine_pump_time: o_chlorine_pump_time || "",
        o_alum_current_gpio: o_alum_gpio || "",
        stop: stop?.toString() || "",
        read_command: read?.toString() || "",
        info: info?.toString() || "",
        status: status?.toString() || "",
        ble_name: ble_name || "",
        rs485_command: e || "",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        // alert("Settings Updated");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      {/* Sidebar */}
      <div
        style={{
          width: "240px",
          background: "linear-gradient(135deg, #8ec5fc, #8ec5fc)",
          color: "#332D56",
          display: "flex",
          flexDirection: "column",
          padding: "0px 0px",
          boxShadow: "4px 0 10px rgba(0,0,0,0.1)",
          minHeight: "100vh",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            marginBottom: 10,
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              fontSize: "100%",
              fontWeight: "bold",
              marginBottom: 0,
              marginTop: 0,
            }}
          >
            <img
              src={require("../img/logo1.png")}
              alt="logo"
              style={{ width: 90 }}
            />
          </div>
        </div>
        {menuItems.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              if (item.label === "Logout") {
                navigate(item.route);
                localStorage.removeItem("role");
                localStorage.removeItem("loginId");
              } else {
                navigate(item.route, { state: { role: item.label } });
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 36px",
              marginBottom: 10,
              borderRadius: 8,
              cursor: "pointer",
              transition: "background 0.3s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#ddd")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <img
              src={item.icon}
              alt={item.label}
              style={{
                width: 22, //filter: "brightness(0) invert(1)"
              }}
            />
            <span style={{ fontSize: "100%", fontWeight: "600" }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div
        className="dashboard-container"
        style={{ flex: 1, overflow: "auto" }}
      >
        <header className="dashboard-header">{threshold.name}</header>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px 0",
          }}
        >
          <button
            className="btn btn-outline-primary"
            onClick={() => navigate("/logs", { state: { id: mac } })}
          >
            📜 Logs
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate("/settings", { state: { id: mac } })}
            style={{ marginRight: 30 }}
          >
            ⚙️ Settings
          </button>
        </div>
        {loading ? (
          <div
            style={{
              width: "80vw",
              height: "70vh",
              display: "flex",
               padding: 20,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader message="Please Wait..." />
          </div>
        ) : (
          <section className="metrics-grid">
            {threshold.rs485 === "true" ? (
              <div>
                <h4
                  style={{
                    margin: "0 0 10px 5px",
                    fontSize: "1.1rem",
                    color: "black",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  PH/ORP/TEMP
                </h4>
                <div
                  className="metric-group-card"
                  style={{
                          background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                          color: "black",
                          padding: "20px",
                          borderRadius: "12px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          display: "flex",
                          flexDirection: "column",
                          gap: "15px",
                          width: isMobile ? "100%" : "200px",  // responsive width
                          minWidth: "100%",
                          flexWrap: "nowrap",
                          alignItems: "center",
                          margin: isMobile ? "0 10px" : "0",  // Optional side margin for spacing

                  }}
                >

                  {[
                    {
                      label: "Temperature",
                      value: threshold?.Temperature ?? "--",
                      unit: "°C",
                      icon: require("../img/temperature.png"),
                      filter:
                        "sepia(100) saturate(100) hue-rotate(-50deg) brightness(100.5)",
                      min: threshold?.temperatureLow,
                      max: threshold?.temperatureHigh,
                    },
                    {
                      label: "PH",
                      value: threshold?.PH ?? "--",
                      icon: require("../img/ph.png"),
                      filter: "",
                      min: threshold?.phLow,
                      max: threshold?.phHigh,
                    },
                    {
                      label: "Conductivity",
                      value: threshold?.DO ?? "--",
                      icon: require("../img/do.png"),
                      filter: "",
                      min: threshold?.DOLow,
                      max: threshold?.DOHigh,
                    },
                    {
                      label: "ORP",
                      value: threshold?.ORP ?? "--",
                      icon: require("../img/orp.png"),
                      filter: "",
                      min: threshold?.ORPLow,
                      max: threshold?.ORPHigh,
                    },
                    {
                      label: "Voltage",
                      value:
                        threshold?.Voltage !== undefined
                          ? parseFloat(threshold?.Voltage).toFixed(2)
                          : "--",
                      icon: require("../img/volt.png"),
                      filter: "",
                      min: threshold?.voltageLow,
                      max: threshold?.voltageHigh,
                    },
                    {
                      label: "Current",
                      value:
                        threshold?.Current !== undefined
                          ? parseFloat(threshold?.Current).toFixed(2)
                          : "--",
                      icon: require("../img/ampere.png"),
                      filter: "",
                      min: threshold?.currentLow,
                      max: threshold?.currentHigh,
                    },
                  ].map((item, index) => {
                    const numericValue = parseFloat(item.value);
                    let backgroundColor = "#f0f0f0"; // default gray

                    if (!isNaN(numericValue)) {
                      if (item.label === "Temperature") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High temp - red
                        else if (numericValue < item.min) backgroundColor = "#0594ed"; // Low temp - blue
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "PH") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High pH - blue
                        else if (numericValue < item.min) backgroundColor = "#ff0000"; // Low pH - red
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "DO") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High do - blue
                        else if (numericValue < item.min) backgroundColor = "#ff0000"; // Low do - red
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "ORP") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High orp - blue
                        else if (numericValue < item.min) backgroundColor = "#ff0000"; // Low orp - red
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "Voltage") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High pH - red
                        else if (numericValue < item.min) backgroundColor = "#ed3b05"; // Low pH - org
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "current") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High pH - red
                        else if (numericValue < item.min) backgroundColor = "#ed3b05"; // Low pH - org
                        else backgroundColor = "#66cc66"; // Normal - green
                      }
                      else {
                        if (numericValue > item.max) backgroundColor = "#0594ed";
                        else if (numericValue < item.min) backgroundColor = "#ff0000";
                        else backgroundColor = "#66cc66";
                      }
                    }

                    return (
                      <div
                        key={index}
                        className="metric-card"
                        style={{
                     borderRadius: "10px",
                      color: "black",
                      padding: "10px",
                      width: isMobile ? "90%" : "400px",
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      alignItems: "center",
                      justifyContent: isMobile ? "center" : "flex-start",
                      textAlign: "center",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      backgroundColor: backgroundColor,
                      margin: "10px auto",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={{
                              width: "30px",
                              height: "30px",
                              color: "black",
                              marginTop: "1px",
                              marginBottom: isMobile ? "10px" : "0",
                              filter: item.filter,
                              objectFit: "contain",
                          }}
                        />
                        <div style={{ marginLeft: "10px" }}>
                          <h3 style={{ margin: 0, textAlign: "center", color: 'black' }}>
                            {item.value === "" ? "0" : item.value} {item.unit ?? ""}
                          </h3>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "2.0vh",
                              textAlign: "center",
                            }}
                          >
                            {item.label}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>

              </div>
            ) : null}
            {threshold.rs4852 === "true" ? (
              <div>
                <h4
                  style={{
                    margin: "0 0 10px 5px",
                    fontSize: "1.1rem",
                    color: "black",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Chlorine/PH/TEMP
                </h4>
                <div
                  className="metric-group-card"
                  style={{
                    background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                    color: "black",
                    padding: "20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    width: '200px',
                    flexWrap: "nowrap",
                    alignItems: "center",

                  }}
                >
                  {[
                    {
                      label: "Temperature",
                      value: threshold?.Temperature ?? "--",
                      unit: "°C",
                      icon: require("../img/temperature.png"),
                      min: threshold?.temperatureLow,
                      max: threshold?.temperatureHigh,
                    },
                    {
                      label: "PH",
                      value: threshold?.PH ?? "--",
                      icon: require("../img/ph.png"),
                      min: threshold?.phLow,
                      max: threshold?.phHigh,
                    },
                    {
                      label: "Conductivity",
                      value: threshold?.DO ?? "--",
                      icon: require("../img/do.png"),
                      min: threshold?.DOLow,
                      max: threshold?.DOHigh,
                    },
                    {
                      label: "ORP",
                      value: threshold?.ORP ?? "--",
                      icon: require("../img/orp.png"),
                      min: threshold?.ORPLow,
                      max: threshold?.ORPHigh,
                    },
                    {
                      label: "Voltage",
                      value:
                        threshold?.Voltage !== undefined
                          ? parseFloat(threshold?.Voltage).toFixed(2)
                          : "--",
                      icon: require("../img/volt.png"),
                      min: threshold?.voltageLow,
                      max: threshold?.voltageHigh,
                    },
                    {
                      label: "Current",
                      value:
                        threshold?.Current !== undefined
                          ? parseFloat(threshold?.Current).toFixed(2)
                          : "--",
                      icon: require("../img/ampere.png"),
                      min: threshold?.currentLow,
                      max: threshold?.currentHigh,
                    },
                  ].map((item, index) => {
                    const numericValue = parseFloat(item.value);
                    let backgroundColor = "#f0f0f0"; // default

                    if (!isNaN(numericValue)) {
                      if (item.label === "Temperature") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High - red
                        else if (numericValue < item.min) backgroundColor = "#0594ed"; // Low -blue
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "PH") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High - blue
                        else if (numericValue < item.min) backgroundColor = "#ff0000"; // Low - red
                        else backgroundColor = "#66cc66";
                      } else if (item.label === "Conductivity") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High pH - blue
                        else if (numericValue < item.min) backgroundColor = "#ff0000"; // Low pH - red
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else if (item.label === "ORP") {
                        if (numericValue > item.max) backgroundColor = "#0594ed"; // High pH - blue
                        else if (numericValue < item.min) backgroundColor = "#66cc66"; // Low pH - grn
                        else backgroundColor = "#ff0000"; // Normal - green
                      } else if (item.label === "Voltage") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High pH - red
                        else if (numericValue < item.min) backgroundColor = "#ed3b05"; // Low pH - org
                        else backgroundColor = "#66cc66"; // Normal - green
                      }
                      else if (item.label === "Current") {
                        if (numericValue > item.max) backgroundColor = "#ff0000"; // High pH - red
                        else if (numericValue < item.min) backgroundColor = "#ed3b05"; // Low pH - org
                        else backgroundColor = "#66cc66"; // Normal - green
                      } else {
                        if (numericValue > item.max) backgroundColor = "#cc370a";
                        else if (numericValue < item.min) backgroundColor = "#ff4d4d";
                        else backgroundColor = "#66cc66";
                      }
                    }

                    return (
                      <div
                        key={index}
                        className="metric-card"
                        style={{
                          borderRadius: "10px",
                          color: "black",
                          padding: "10px",
                          width: "300px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          textAlign: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                          backgroundColor,
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={{
                            width: "30px",
                            height: "30px",
                            marginTop: "1px",
                            objectFit: "contain",
                          }}
                        />
                        <div style={{ marginLeft: "10px" }}>
                          <h3 style={{ margin: 0, textAlign: "center", color: "black" }}>
                            {item.value === "" ? "0" : item.value} {item.unit ?? ""}
                          </h3>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "2.0vh",
                              textAlign: "center",
                              color: "black",
                            }}
                          >
                            {item.label}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}

            {threshold.dosing === "true" ? (
              <div>
                <h4
                  style={{
                    margin: "0 0 10px 5px",
                    fontSize: "1.1rem",
                    color: "#333",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Acid
                </h4>
                <div
                  className="metric-group-card"
                  style={{
                    background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                    padding: "20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                 
                    flexDirection: "column",
                    gap: "15px",
                    width: '200px',
                    flexWrap: "nowrap",
                    alignItems: "center",
                  }}
                >
                  {[
                    {
                      label: "Time On",
                      value: threshold?.time_on ?? "--",
                      icon: require("../img/timing.png"),
                    },
                    {
                      label: "Delay After On",
                      value: threshold?.delay_after_on ?? "--",
                      icon: require("../img/wait-time.png"),
                    },
                    {
                      label: "PH Active Time",
                      value: threshold?.ph_active_time ?? "--",
                      icon: require("../img/ph1.png"),
                    },
                    {
                      label: "Start Active On",
                      value: threshold?.start_active_on ?? "--",
                      icon: require("../img/start.png"),
                    },
                    {
                      label: "Dosing GPIO 3 Threshold",
                      value: threshold?.dosign_acid_current_gpio ?? "--",
                      icon: require("../img/ph.png"),
                    },
                    {
                      label: "Chlorine Pump Time",
                      value: threshold?.chlorine_pump_time ?? "--",
                      icon: require("../img/chlorine.png"),
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="metric-card"
                      style={{
                        background: "rgba(255,255,255,0.85)",
                        borderRadius: "10px",
                        padding: "10px",
                        width: "400px",
                        display: "flex",
                        flexDirection: "row", 
                        alignItems: "center",
                        justifyContent: "flex-start",
                        textAlign: "center",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginTop: "1px",
                          objectFit: "contain", // Ensures the icon fits nicely
                        }}
                      />
                      <div style={{ marginLeft: "10px" }}>
                        <h3 style={{ margin: 0, textAlign: "center" }}>
                          {item.value === "" ? "0" : item.value}{" "}
                          {item.unit ?? ""}
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "2.0vh",
                            textAlign: "center",
                          }}
                        >
                          {item.label}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            {threshold.dosing2 === "true" ? (
              <div>
                {/* Title */}
                <h4
                  style={{
                    margin: "0 0 10px 5px",
                    fontSize: "1.1rem",
                    color: "#333",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Others
                </h4>
                <div
                  className="metric-group-card"
                  style={{
                    background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                    padding: "20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    width: '200px',
                    flexWrap: "nowrap",
                    alignItems: "center",
                  }}
                >
                  {[
                    {
                      label: "Time On",
                      value: threshold?.time_on ?? "--",
                      icon: require("../img/timing.png"),
                    },
                    {
                      label: "Delay After On",
                      value: threshold?.delay_after_on ?? "--",
                      icon: require("../img/wait-time.png"),
                    },
                    {
                      label: "PH Active Time",
                      value: threshold?.ph_active_time ?? "--",
                      icon: require("../img/ph1.png"),
                    },
                    {
                      label: "Start Active On",
                      value: threshold?.start_active_on ?? "--",
                      icon: require("../img/start.png"),
                    },
                    {
                      label: "Dosing GPIO 3 Threshold",
                      value: threshold?.dosign_acid_current_gpio ?? "--",
                      icon: require("../img/ph.png"),
                    },
                    {
                      label: "Chlorine Pump Time",
                      value: threshold?.chlorine_pump_time ?? "--",
                      icon: require("../img/chlorine.png"),
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="metric-card"
                      style={{
                        background: "rgba(255,255,255,0.85)",
                        borderRadius: "10px",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        width: '200px',
                        flexWrap: "nowrap",

                        alignItems: "center", // Center horizontally
                        justifyContent: "flex-start",
                        textAlign: "center",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginTop: "1px",
                          objectFit: "contain", // Ensures the icon fits nicely
                        }}
                      />
                      <div style={{ marginLeft: "10px" }}>
                        <h3 style={{ margin: 0, textAlign: "center" }}>
                          {item.value === "" ? "0" : item.value}{" "}
                          {item.unit ?? ""}
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "2.0vh",
                            textAlign: "center",
                          }}
                        >
                          {item.label}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}

            {threshold.sand_filter === "true" ? (
              <div>
                <h4
                  style={{
                    margin: "0 0 10px 5px",
                    fontSize: "1.1rem",
                    color: "#333",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Sand Filter
                </h4>

                <div
                  className="metric-group-card"
                  style={{
                    background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                    padding: "20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    width: '200px',
                    flexWrap: "nowrap",
                    alignItems: "center",
                  }}
                >
                  {[
                    {
                      label: "PWM",
                      value: threshold?.run_station?.split(",")[1] ?? "--",
                      icon: require("../img/timing.png"),
                    },
                    {
                      label: "Station",
                      value: threshold?.run_station?.split(",")[0] ?? "--",
                      icon: require("../img/wait-time.png"),
                    },
                    {
                      label: "Stop",
                      value: threshold?.stop ?? "--",
                      icon: require("../img/ph1.png"),
                    },
                    {
                      label: "Read",
                      value: threshold?.read_command ?? "--",
                      icon: require("../img/start.png"),
                    },
                    {
                      label: "Status",
                      value: threshold?.status ?? "--",
                      icon: require("../img/ph.png"),
                    },
                    {
                      label: "RS485",
                      value: threshold?.rs485_command ?? "--",
                      icon: require("../img/chlorine.png"),
                    },
                  ].map((item, index) => (
                    <>
                      <div
                        key={index}
                        className="metric-card"
                        style={{
                          background: "rgba(255,255,255,0.85)",
                          borderRadius: "10px",
                          padding: "10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "15px",
                          width: '200px',
                          flexWrap: "nowrap",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginLeft: "0px" }}>
                          {item.label === "PWM" || item.label === "Station" ? (
                            <h3 style={{ margin: 0, textAlign: "center" }}>
                              {item.value === "true" ? "0" : item.value}{" "}
                              {item.unit ?? ""}
                            </h3>
                          ) : (
                            <div
                              style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                backgroundColor:
                                  item.value === "true" ? "#28a745" : "#dc3545", // Green or Red
                                border: "2px solid white",
                                boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                marginBottom: 5,
                              }}
                            ></div>
                          )}
                          <p
                            style={{
                              margin: 0,
                              fontSize: "2.0vh",
                              textAlign: "center",
                            }}
                          >
                            {item.label}
                          </p>
                        </div>
                        {item.label === "RS485" && (
                          <label
                            className="toggle-switch"
                            style={{
                              alignSelf: "flex-start",
                              marginTop: 4,
                              marginLeft: 10,
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={rs485command === "true"}
                              onChange={async (e) => {
                                setrs485command(e.target.checked.toString());
                                sendthreshold(e.target.checked.toString());
                              }}
                            />
                            <span className="slider"></span>
                          </label>
                        )}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            ) : null}
          </section>
        )}
      </div>
    </div >
  );
};

export default View;
